@for (ctrl of nominees.controls; track i; let i = $index) {
    <div class="nominee-card" [formGroup]="asGroup(ctrl)">
        <div class="nominee-card-head">
            <h4>Nominee {{ i + 1 }}</h4>
            <p-button icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger"
                (onClick)="removeNominee.emit(i)" />
        </div>

        <div class="field">
            <label>Nominee Name <span class="req">*</span></label>
            <input pInputText type="text" formControlName="nomineeName" placeholder="Full name as per records"
                style="text-transform: uppercase">
            @if (asGroup(ctrl).get('nomineeName')?.touched && asGroup(ctrl).get('nomineeName')?.invalid) {
                <small class="err">Nominee name is required</small>
            }
        </div>

        <div class="grid-2">
            <div class="field">
                <label>Date of Birth <span class="req">*</span></label>
                <p-datepicker formControlName="dateOfBirth" dateFormat="dd M yy" [showIcon]="true"
                    iconDisplay="input" [readonlyInput]="true" [maxDate]="today" appendTo="body"
                    placeholder="Date of birth" />
                @if (asGroup(ctrl).get('dateOfBirth')?.touched && asGroup(ctrl).get('dateOfBirth')?.invalid) {
                    <small class="err">Date of birth is required</small>
                }
            </div>
            <div class="field">
                <label>Relationship <span class="req">*</span></label>
                <p-select [options]="relationshipOptions" optionLabel="label" optionValue="label"
                    [editable]="true" formControlName="relationship" placeholder="Select relationship"
                    appendTo="body" />
                @if (asGroup(ctrl).get('relationship')?.touched && asGroup(ctrl).get('relationship')?.invalid) {
                    <small class="err">Relationship is required</small>
                }
            </div>
        </div>

        <div class="field">
            <label>Nomination %</label>
            <input pInputText type="number" formControlName="nominationPercentage" min="0" max="100">
        </div>

        <!-- Contact defaults to the member's own; uncheck to enter the nominee's details. -->
        <div class="same-check">
            <p-checkbox formControlName="sameAsMember" [binary]="true" inputId="same{{ i }}"
                (onChange)="sameAsMemberToggle.emit(i)" />
            <label [attr.for]="'same' + i">Same as member — use the member's mobile, address &amp; email</label>
        </div>

        <div class="grid-2">
            <div class="field">
                <label>Mobile Number <span class="req">*</span></label>
                <input pInputText type="text" formControlName="mobileNumber" appDigitsOnly="10"
                    inputmode="numeric" maxlength="10" placeholder="10-digit mobile">
                @if (asGroup(ctrl).get('mobileNumber')?.touched && asGroup(ctrl).get('mobileNumber')?.invalid) {
                    <small class="err">Enter a valid 10-digit mobile</small>
                }
            </div>
            <div class="field">
                <label>Email</label>
                <input pInputText type="email" formControlName="email" placeholder="name@example.com">
                @if (asGroup(ctrl).get('email')?.touched && asGroup(ctrl).get('email')?.invalid) {
                    <small class="err">Invalid email</small>
                }
            </div>
        </div>

        <div class="field">
            <label>Address <span class="req">*</span></label>
            <textarea class="form-textarea" rows="2" formControlName="address"
                placeholder="Residential address"></textarea>
            @if (asGroup(ctrl).get('address')?.touched && asGroup(ctrl).get('address')?.invalid) {
                <small class="err">Address is required</small>
            }
        </div>
    </div>
}

<div class="add-row">
    <p-button label="Add nominee" icon="pi pi-plus" [outlined]="true" (onClick)="addNominee.emit()" />
</div>

@if (nominees.length) {
    <div class="total-row">
        <span>Total nomination: {{ totalPercentage() }}%</span>
        @if (totalPercentage() !== 100) {
            <p-message severity="warn" text="Nomination percentages across all nominees must total 100%." />
        } @else {
            <small class="ok">Percentages add up to 100%.</small>
        }
    </div>
} @else {
    <small class="empty-hint">Nominees are optional — add one only if needed.</small>
}
